export default __webpack_public_path__ + "static/media/Shortlist.4b7815a0.svg";